<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								Cotización #<strong v-if="quote">{{quote.Number}}</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body>
						<b-row>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha: </span> {{quote.CreatedOn|dateFormatFull}}
								</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Nombre: </span> {{quote.Name}}
								</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Estado: </span> {{quote.State}}
								</h6>
							</b-col>
							<b-col md="4" lg="3" v-if="quote.Company">
								<h6><span class="text-info">Compañia: </span> {{quote.Company}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="quote.IncidentNumber">
								<h6><span class="text-info"># Caso: </span> {{quote.IncidentNumber}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="quote.Incident">
								<h6><span class="text-info">Caso: </span> {{quote.Incident}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="quote.AuthUser">
								<h6><span class="text-info">Usuario que Aprobó: </span> {{quote.AuthUser.firstName}}
									{{quote.AuthUser.lastName}}
								</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="quote.AuthDate">
								<h6><span class="text-info">Fecha de Aprobación: </span>
									{{quote.AuthDate|dateFormatFull}}
								</h6>
							</b-col>
						</b-row>

						<b-row class="mt-5">
							<b-col md="12" lg="12" class="table-responsive">
								<b-table :items="quote.Products"
										 :fields="tableFields"
										 :busy="loading"
										 show-empty
										 striped
										 empty-filtered-text="No hay productos disponibles"
										 empty-text="No hay productos disponibles">
									<div slot="UnitPrice" slot-scope="item">
										{{currencySymbol}}{{item.item.UnitPrice|formatPrice}}
									</div>

									<div slot="Discount" slot-scope="item">
										{{currencySymbol}}{{item.item.Discount|formatPrice}}
									</div>

									<div slot="Taxes" slot-scope="item">
										{{currencySymbol}}{{item.item.Taxes|formatPrice}}
									</div>

									<div slot="Total" slot-scope="item">
										{{currencySymbol}}{{item.item.Total|formatPrice}}
									</div>
								</b-table>
							</b-col>
						</b-row>

						<b-row>
							<b-col md="6" lg="6" class="d-flex flex-column">
								<strong>Observaciones:</strong>
								<p>{{quote.Notes}}</p>
							</b-col>
							<b-col md="6" lg="6" class="d-flex flex-column">
								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Sub Total</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{quote.SubTotal|formatPrice}}
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Descuento</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{quote.TotalDiscount|formatPrice}}
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Total Impuestos</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										{{currencySymbol}}{{quote.TotalTaxes|formatPrice}}
									</b-col>
								</b-row>

								<b-row>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>Total</strong>
									</b-col>
									<b-col md="6" lg="6" sm="6" cols="6" class="text-right">
										<strong>{{currencySymbol}}{{quote.TotalAmount|formatPrice}}</strong>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
						<b-row class="justify-content-center mt-3">
							<b-col class="mt-3" md="12" lg="12" v-if="successMessage">
								<b-alert variant="success" dismissible show class="mb-4 w-100 text-center">
									{{successMessage}}
								</b-alert>
							</b-col>
							<b-col md="4" lg="4">
								<b-button variant="success"
										  class="btn-block btn-sm"
										  v-if="canAuth && quote && !isApproved"
										  v-b-modal.confirm-auth-modal>
									<i class="fa fa-check" aria-hidden="true"></i> Autorizar
								</b-button>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
		<b-modal
			id="confirm-auth-modal"
			ref="modal"
			title="Autorización de Cotización"
			centered
			ok-title="Autorizar"
			cancel-title="Cancelar"
			ok-variant="success"
			@ok="handleOK">
			<div v-if="accountSelected.RequiredPurchaseOrder">
				<b-form-group>
					<label class="text-black-50"><b>Número de Orden de Compra:</b></label>
					<b-input type="text" v-model="purchaseOrderNumber"></b-input>
					<small v-if="purchaseOrderNumberError" class="text-danger"><b>El Número de Orden es
						requerido.</b></small>
				</b-form-group>
				<b-form-group>
					<label class="text-black-50"><b>Archivo de la Orden de Compra:</b></label>
					<b-form-file
						variant="info"
						id="purchase-order"
						v-model="file"
						:state="Boolean(file)"
						browse-text="Explorar"
						placeholder="Seleccione un archivo o arrastre uno..."
						drop-placeholder="Arrastre un archivo aquí..."
						accept=".pdf, .jpg, .png, jpeg"
					></b-form-file>
					<small class="text-muted">El archivo puede ser en formato PDF, JPG, JPEG o PNG. Este campo es
						opcional, pero se recomienda si tiene la Orden de Compra en digital la adjunte.</small>
				</b-form-group>
			</div>
			<div v-else>
				<h5 class="text-center">¿Está seguro de autorizar está Cotización?</h5>
			</div>
			<b-row class="justify-content-center" v-if="authLoader">
				<b-col md="12" lg="12" class="text-center">
					Autorizando...
				</b-col>
				<b-col md="1" lg="1" class="text-center">
					<b-spinner variant="info" label="Autorizando..."></b-spinner>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapState} from "vuex";

	export default {
		name: "QuoteDetail",
		components: {
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				loading: false,
				quote: '',
				tableFields: {
					Name: {
						label: 'Nombre del Producto'
					},
					UnitPrice: {
						label: 'Precio Unitario'
					},
					Qty: {
						label: 'Cantidad'
					},
					Discount: {
						label: 'Descuento'
					},
					Taxes: {
						label: 'Impuestos'
					},
					Total: {
						label: 'Total'
					}
				},
				currencySymbol: '',
				authLoader: false,
				successMessage: '',
				file: null,
				purchaseOrderNumber: '',
				purchaseOrderNumberError: false
			}
		},
		mounted() {
			const quoteId = this.$route.params.id;

			if (this.accountSelected !== '') {
				this.getQuoteDetail(quoteId);
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			handleOK(bvModalEvt) {
				bvModalEvt.preventDefault();

				this.purchaseOrderNumberError = false;

				if (this.accountSelected.RequiredPurchaseOrder && !this.purchaseOrderNumber) {
					this.purchaseOrderNumberError = true;
					return;
				}

				this.authLoader = true;

				this.$store.dispatch('authQuote', {
					Id: this.quote.Id,
					file: this.file,
					purchaseOrder: this.purchaseOrderNumber
				})
					.then((response) => {
						this.successMessage = response;
						this.getQuoteDetail(this.quote.Id);

						this.$nextTick(() => {
							this.$bvModal.hide('confirm-auth-modal');
						});
					})
					.finally(() => {
						this.authLoader = false;
					});
			},
			getQuoteDetail(quoteId) {
				this.loading = true;
				this.$store.dispatch('getQuoteDetail', quoteId)
					.then((quote) => {
						console.log(quote);
						this.quote = quote;

						if (quote.Currency) {
							this.currencySymbol = quote.Currency
						}
					})
					.catch((error) => {
						console.log(error);
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})
			}
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected,
				user: state => JSON.parse(state.user),
			}),
			canAuth() {
				if (this.accountSelected && this.accountSelected.AuthQuoteUser && this.accountSelected.AuthQuoteUser.userID == this.user.userID) {
					return true;
				} else {
					return false;
				}
			},
			isApproved() {
				if (this.quote && this.quote.AuthUser && this.quote.AuthDate){
					return true;
				}
				else {
					return false;
				}
			}
		}
	}
</script>

<style scoped>

</style>
